import { render } from "./Temp.vue?vue&type=template&id=6a6c8706&scoped=true"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"

import "./Temp.vue?vue&type=style&index=0&id=6a6c8706&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a6c8706"

export default script